import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../Common/Loader";
import SmallLoader from "../../Common/smallLoader";
import { checkEmpty, decryptData, goToClientDashboard, noDataFound, splitDate, splitDateSlash } from "../../../CommonMethhods/CommonMethods";
import { partner_Admin, partner_Api, partner_Side_Url } from "../../../Configuration/Partner_URL";
import { useNavigate } from "react-router-dom";
import { axiosPartnerBlob, axiosPartnerFormData, axiosPartnerText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function PartnerSideTopActiveClientTable(props) {
  const partnerId = localStorage.getItem("partnerId");
  const storeToken = localStorage.getItem("ssoToken");
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const [activeClientInfo, setActiveClientInfo] = useState([]);
  const [loader, setLoader] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [dataType, setDataType] = useState("json");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const accountOpened = "opened";
  const navigate = useNavigate();

  const getActiveClientTableInfo = async () => {
    try {
      const getActiveInFo = await axiosPartnerText.get(
        `${partner_Api.GET_ACTIVE_CLIENT}?pCode=${partnerId}&page=${page}&limit=${pageSize}&state=active&dataType=${dataType}`,
        
      );

      const res = decryptData(getActiveInFo?.data);
      let decryptedResp = JSON.parse(res);
      setCount(decryptedResp?.data?.info?.count);

      if (decryptedResp?.status === 0) {
        if (showModal === true) {
          if (dataType == "json") {
            setActiveClientInfo((prev) => {
              return [...prev, ...decryptedResp?.data?.info?.clients];
            });
          }
        }
        else {
          setActiveClientInfo(decryptedResp?.data?.info?.clients);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  const handleScroll = (e) => {
    setDataType("json");
    if (showModal == true) {
      setPageSize(5);
      const a = document.querySelector("#abcd1");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        if (count <= pageSize * page) {
          setScrollLoader(false);
          return;
        }
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    } else {
      setPage(1);
    }
  };

  const handleViewClick = () => {
    setShowModal(true);
    getActiveClientTableInfo();
  };
  useEffect(() => {
    if (partnerId) {
      getActiveClientTableInfo();
    }
  }, [page, partnerId]);

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setPageSize(5);
    setDataType("json");
    // setActiveClientInfo(active)
  };

  const showActiveData = (activeClientInfo) => {
    return (
      activeClientInfo &&
      activeClientInfo.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <span className="idColor"
                onClick={() => {
                  localStorage.setItem("ClientId2", info?.clientCode);
                  {
                    info?.clientCode &&
                    getClientType(info?.clientCode)
                  }




                  // goToClientDashboard(info?.cCode, "");
                }}
              >
                {checkEmpty(info?.clientCode) ? "-" : info?.clientCode}
              </span>
            </td>
            <td>{checkEmpty(info?.name) ? "-" : info?.name}</td>
            <td>
              {checkEmpty(info?.email)
                ? "-"
                : info?.email}
            </td>
            <td>
              {checkEmpty(info?.bankName) ? "-" : info?.bankName}
            </td>
          </tr>
        );
      })
    );
  };

  const showModalActiveData = (activeClientInfo) => {
    return (
      activeClientInfo &&
      activeClientInfo.map((info, index) => {
        // const timestamp = info?.accOpenDate;
        // const accDate = timestamp.split('T')[0];
        // console.log(accDate);
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
              <span className="idColor"
                onClick={() => {
                  localStorage.setItem("ClientId2", info?.clientCode);
                  {
                    info?.clientCode &&
                    getClientType(info?.clientCode)
                  }
                  // goToClientDashboard(info?.cCode, "");
                }}
              >
                {checkEmpty(info?.clientCode) ? "-" : info?.clientCode}
              </span>
            </td>
            <td>{checkEmpty(info?.name) ? "-" : info?.name}</td>
            <td>{checkEmpty(info?.mobile) ? "-" : info?.mobile}</td>
            <td>
              {checkEmpty(info?.email)
                ? "-"
                : info?.email}
            </td>
            <td>
              {checkEmpty(info?.leadCreateDate) ? "-" : splitDate(info?.leadCreateDate)}
            </td>

            <td>
              {checkEmpty(info?.accOpenDate) ? "-" : splitDate(info?.accOpenDate)}
            </td>
            <td>
              {checkEmpty(info?.brkgPlan) ? "-" : info?.brkgPlan}
            </td>
            <td>
              {checkEmpty(info?.lastTradedDate) ? "-" : splitDate(info?.lastTradedDate)}
            </td>
            <td>
              {checkEmpty(info?.yestBrkg) ? "-" : info?.yestBrkg}
            </td>
            <td>
              {checkEmpty(info?.currentMonthTrade) ? "-" : info?.currentMonthTrade}
            </td>
            <td>
              {checkEmpty(info?.monthlyBrkg) ? "-" : info?.monthlyBrkg}
            </td>
            <td>
              {checkEmpty(info?.totTrades) ? "-" : info?.totTrades}
            </td>
            <td>
              {checkEmpty(info?.brkg) ? "-" : info?.brkg}
            </td>
            <td>
              {checkEmpty(info?.mtfBook) ? "-" : info?.mtfBook}
            </td>
            <td>
              {checkEmpty(info?.turnover) ? "-" : info?.turnover}
            </td>
            <td>
              {checkEmpty(info?.bankName) ? "-" : info?.bankName}
            </td>

          </tr>
        );
      })
    );
  };

  const downloadFile = async (url, type) => {
    console.log(url, "urlExcel");
    setDataType(type);
    if (type === "csv") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    }
    try {
      const response = await axiosPartnerFormData.get(url)
      const headers = response?.headers
      if (headers["content-type"] !== "text/csv") {
        toast.error("No Data Found")
        return
      }
      const binary = [];
      binary.push(response?.data);
      console.log(response.data,"response");
      
      const partnerId = localStorage.getItem("partnerId");
      const filename = `${partnerId}_TOP_ACTIVE_CLIENTS.csv`;
      const href = window.URL.createObjectURL(new Blob(binary, { type: "text/csv" }))
      const link = document.createElement("a")
      link.href = href
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click();

      document.body.removeChild(link)
      window.URL.revokeObjectURL(href);
    } catch (error) {
      console.error("Error during file download:", error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setLoader(false);
    }
  };

  const downloadFilePdf = async (url, type) => {
    setDataType(type);
    if (type === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    }
    try {
      const response = await axiosPartnerBlob.get(url)


      const headers = response?.headers
      if (headers["content-type"] !== "application/pdf") {
        toast.error("No Data Found")
        return
      }
      const binary = [];
      binary.push(response?.data)
       const partnerId = localStorage.getItem("partnerId");
      const filename = `${partnerId}_TOP_ACTIVE_CLIENTS.pdf`;
      const href = window.URL.createObjectURL(response?.data)
      const link = document.createElement("a")
      link.href = href
      link.setAttribute("download",filename)
      document.body.appendChild(link)
      link.click();

      document.body.removeChild(link)
      window.URL.revokeObjectURL(href);
    } catch (error) {
      console.error("Error during file download:", error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setLoader(false);
    }

  };


  const getClientType = async (id) => {
    try {
      const getEditResp = await axiosPartnerText.get(
        `${partner_Admin.GET_CLIENT_TYPE}${id}`,
      );
      let respData = decryptData(getEditResp.data);
      let decryptedResp = JSON.parse(respData);
      if (decryptedResp?.status === 0) {
        const clientType = decryptedResp?.data?.info;

        if (clientType?.client_type !== "") {
          localStorage.setItem("partnerPan", clientType?.pan);
          localStorage?.setItem("tabOnboarding", clientType?.client_type)
          navigate("/partner-dashboard")
        }

      } else {
        toast.error(decryptedResp?.message)
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="card-box activeclient partner-active">
      <div className="card-title">
        <div className="figure-inlac">
          <h2>{Constants.Top_Active_Clients}</h2>

        </div>
        {activeClientInfo && activeClientInfo?.length > 0 ? (
          <div className="view-more-wrapper">
            <button className="view-more" onClick={handleViewClick}>
              {Constants.View_All}
            </button>
          </div>
        ) : (
          ""
        )}
        <div className="card-right">
        </div>
      </div>
      <div className="scroll-table active-table">
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : activeClientInfo && activeClientInfo.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>{Constants.Client_Code}</th>
                <th>{Constants.Name}</th>
                <th>{Constants.EMAIL}</th>
                <th>{Constants.BANK_NAME}</th>
              </tr>
            </thead>

            <tbody>{showActiveData(activeClientInfo)}</tbody>
          </table>
        ) : serverError === "Something went wrong, Please try again later." ? (
          <h4 className="no-data">{serverError}</h4>
        ) : (
          noDataFound()
        )}
      </div>

      <Modal
        show={showModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">{Constants.Top_Active_Clients}</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table partner-active">
            <table className="table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>{Constants.Client_Code}</th>
                  <th>{Constants.Name}</th>
                  <th>{Constants.Mobile}</th>
                  <th>{Constants.EMAIL}</th>
                  <th>Lead Created Date</th>
                  <th>Account Open Date</th>
                  <th>Pack</th>
                  <th>Last Traded Date</th>
                  <th>Yesterday Brokerage</th>
                  <th>Current Month Trades</th>
                  <th>Current Month Brokerage</th>
                  <th>Total Trades</th>
                  <th>Total Brokerage</th>
                  <th>MTF Book</th>
                  <th>Turnover</th>
                  <th>{Constants.BANK_NAME}</th>
                </tr>
              </thead>

              <tbody id="abcd1" onScroll={handleScroll}>
                {showModalActiveData(activeClientInfo)}
                {scrollLoader && (
                  <div className="loader-center">
                    <SmallLoader />
                  </div>
                )}
              </tbody>
            </table>
          </div>
          <div className="generate-btn-wrapper">

            <button
              className="generate-btn text-green"
            >
              <div className="text-green partner-excel"
                onClick={() => downloadFile(`${partner_Side_Url}/partner/active-clients?pCode=${partnerId}&page=${1}&limit=${-1}&state=active&dataType=csv`, "csv")}

              >
                {smallLoaderExcel ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    {"Excel"}
                  </>
                )}
              </div>
            </button>

            <button
              className="generate-btn txt-purple"
            >
              <div
                onClick={() => downloadFilePdf(`${partner_Side_Url}/partner/active-clients?pCode=${partnerId}&page=${1}&limit=${-1}&state=active&dataType=pdf`, "pdf")}
                className="txt-purple partner-pdf"
              >
                {smallLoaderPdf ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span> {"PDF"}
                  </>
                )}
              </div>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default PartnerSideTopActiveClientTable;
